import { format, isSameDay, isSameWeek, subDays } from "date-fns";
import { ptBR } from "date-fns/locale";

// ----------------------------------------------------------------------
// Datas do chat.
//
// Não reusa `fDate` de formatTime.ts de propósito: aquela função faz
// `date.split("T")[0]` e remonta o Date com os componentes da string ISO, que
// vem em UTC. Perto da meia-noite o separador de dia sairia no dia errado.
// ----------------------------------------------------------------------

type InputValue = Date | string | number | null;

function parse(date: InputValue): Date | null {
  if (!date) return null;
  const parsed = new Date(date);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

/** Hora curta dentro da bolha: `14:32`. */
export function fMessageTime(date: InputValue): string {
  const parsed = parse(date);
  return parsed ? format(parsed, "HH:mm", { locale: ptBR }) : "";
}

/** Chave de agrupamento por dia, no fuso local. */
export function fDayKey(date: InputValue): string {
  const parsed = parse(date);
  return parsed ? format(parsed, "yyyy-MM-dd") : "sem-data";
}

/** Rótulo do separador: `Hoje`, `Ontem`, `quinta-feira` ou `03/02/2026`. */
export function fDayLabel(date: InputValue): string {
  const parsed = parse(date);
  if (!parsed) return "Sem data";

  const now = new Date();

  if (isSameDay(parsed, now)) return "Hoje";
  if (isSameDay(parsed, subDays(now, 1))) return "Ontem";
  // Dentro da semana corrente o dia da semana é mais legível que a data.
  if (isSameWeek(parsed, now, { locale: ptBR })) {
    return format(parsed, "EEEE", { locale: ptBR });
  }

  return format(parsed, "dd/MM/yyyy", { locale: ptBR });
}
